import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector     : 'vg-layout',
    templateUrl  : './layout.component.html',
    styleUrls    : ['./layout.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class VoucherGeneratorLayoutComponent
{
    isSidebarOpen = false;
    isDesktopSidebarCollapsed = false;

    constructor()
    {
    }

    toggleSidebar(): void {
        const isMobile = window.innerWidth < 768;
        
        if (isMobile) {
            this.isSidebarOpen = !this.isSidebarOpen;
        } else {
            this.isDesktopSidebarCollapsed = !this.isDesktopSidebarCollapsed;
        }
    }
}
